import { clsx } from 'clsx';
import { getDefaultConfig, createTailwindMerge, mergeConfigs } from 'tailwind-merge';
import { createTV } from 'tailwind-variants';

var defaultConfig = getDefaultConfig();

// can't include '' blank,
// we don't want the color token to remove `border` which tailwind default is assign it to border-width: 1px
// for `outline` we don't want to remove it because it is assigned to outline-style: solid
var border = ['inherit', 'current', 'transparent', 'primary', 'neutral', 'base', 'base-inverse', 'status-informative', 'status-caution', 'status-positive', 'status-negative', 'accent-emphasize', 'accent-highlight', 'accent-highlight-subtle', 'accent-highlight-bold', 'accent-highlight-strong', 'action-neutral', 'action-base', 'action-base-inverse', 'hover', 'focus', 'disable', 'selected'];
var text = ['', 'none', 'inherit', 'current', 'base', 'neutral-bold', 'neutral-strong', 'neutral-contrast', 'status-informative', 'status-caution', 'status-positive', 'status-negative', 'accent-highlight', 'accent-emphasize', 'action-primary', 'action-primary-hover', 'action-primary-active', 'action-neutral', 'action-neutral-hover', 'action-neutral-active', 'action-base-inverse', 'action-base-inverse-hover', 'action-base-inverse-active', 'disabled', 'selected', 'on-primary', 'on-primary-subtlest', 'on-primary-subtler', 'on-primary-moderate', 'on-primary-contrast', 'on-neutral', 'on-neutral-subtlest', 'on-neutral-subtler', 'on-neutral-subtle', 'on-neutral-moderate', 'on-neutral-bold', 'on-neutral-strong', 'on-base', 'on-base-alt', 'on-status-informative', 'on-status-caution', 'on-status-positive', 'on-status-negative', 'on-accent-highlight', 'on-accent-emphasize', 'on-accent-hover', 'on-action-primary', 'on-action-primary-hover', 'on-action-primary-active', 'on-action-secondary', 'on-action-secondary-hover', 'on-action-secondary-active', 'on-action-neutral', 'on-action-neutral-hover', 'on-action-neutral-active', 'on-action-base', 'on-action-base-hover', 'on-action-base-active', 'on-disabled'];
var emUnits = ['e-0.0625', 'e-0.125', 'e-0.1875', 'e-0.25', 'e-0.3125', 'e-0.375', 'e-0.4375', 'e-0.5', 'e-0.625', 'e-0.75', 'e-0.875', 'e-1.0', 'e-1.125', 'e-1.25', 'e-1.375', 'e-1.5', 'e-1.75', 'e-1.875', 'e-2.0', 'e-2.25', 'e-2.375', 'e-2.5'];
function getCustomConfig() {
  return mergeConfigs(defaultConfig, {
    override: {
      classGroups: {
        'font-size': [{
          text: ['base', 'p-8', 'p-10', 'p-12', 'p-14', 'p-16', 'p-18', 'p-20',
          //'p-22',
          'p-24', 'p-28', 'p-32', 'p-36', 'p-42', 'e-0.25', 'e-0.5', 'e-0.625', 'e-0.75', 'e-0.875', 'e-1.0', 'e-1.125', 'e-1.25',
          //'e-1.375',
          'e-1.5', 'e-1.75', 'e-1.875', 'e-2.0', 'e-2.25',
          //'e-2.375',
          //'e-2.5',
          'e-2.625']
        }],
        color: [{
          text: text
        }],
        'border-color': [{
          border: border
        }],
        margin: [{
          margin: emUnits
        }],
        padding: [{
          padding: emUnits
        }],
        height: [{
          height: emUnits
        }],
        'outline-color': [{
          outline: border
        }],
        shadow: [{
          shadow: ['elevation-20', 'elevation-35', 'footer-inset', 'glow', 'popover', 'std']
        }]
      }
    }
  });
}
function getTvObject(object) {
  return object;
}
var tv = createTV({
  twMergeConfig: getCustomConfig()
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var twMerge = createTailwindMerge(getCustomConfig);
function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return twMerge(clsx(inputs));
}

export { cn, getTvObject, tv, twMerge };
//# sourceMappingURL=index.esm.js.map
